import React, { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap";
import cx from "clsx";

import { ModalManager } from "components";

import AdminModal from "modules/Admin/components/Create";
import TeacherModal from "modules/Teacher/components/Create";
import CategoryModal from "modules/Category/components/Create";
import SubscriptionModal from "modules/Subscription/components/CreateUpdate";

const TRANSLATION_BASE = "quickCreate";

const QuickCreateDropdown = ({ quickCreations }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <ModalManager
      initialValue={{
        admin: { isOpen: false },
        teacher: { isOpen: false },
        category: { isOpen: false },
        subscription: { isOpen: false }
      }}>
      {({ modal, openModal, closeModal }) => {
        return (
          <Fragment>
            <AdminModal isOpen={modal["admin"].isOpen} onClose={() => closeModal("admin")} />
            <TeacherModal isOpen={modal["teacher"].isOpen} onClose={() => closeModal("teacher")} />
            <CategoryModal isOpen={modal["category"].isOpen} onClose={() => closeModal("category")} />
            <SubscriptionModal isOpen={modal["subscription"].isOpen} onClose={() => closeModal("subscription")} />

            <UncontrolledDropdown>
              <DropdownToggle
                tag="button"
                className="btn btn-link nav-link dropdown-toggle waves-effect waves-light"
                style={{ paddingRight: 40 }}>
                {t(`${TRANSLATION_BASE}.create_new`)}
                <i className="mdi mdi-chevron-down"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-animated topbar-dropdown-menu profile-dropdown" style={{ width: "auto" }}>
                {quickCreations.map((item, key) => (
                  <button
                    key={key}
                    className="btn btn-light dropdown-item"
                    onClick={() => (item.page ? history.push(item.link) : openModal(item.link))}>
                    <i className={cx(item.icon, "mr-1")}></i>
                    <span>{item.title}</span>
                  </button>
                ))}

                <DropdownItem divider />
                <a href="https://napaautomative.com" target="_blank" className="dropdown-item">
                  <i className="fe-headphones mr-1"></i>
                  <span>{t("global.help_and_support")}</span>
                </a>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Fragment>
        );
      }}
    </ModalManager>
  );
};

export default QuickCreateDropdown;
